import {  Drawer, List, useMediaQuery, useTheme, } from '@mui/material'
import { logo } from '../../constants/images'
import { CardDrawer, HeadDrawer, ListItemButtonDrawer, ListItemDrawer, ListItemIconDrawer, ListItemTextDrawer } from './drawerStyle';
import { useLocation, useNavigate } from 'react-router-dom';
// import { getProfile } from '../../utils/app.utils';
import routes from '../../router';
import _ from 'lodash';
import { menuFirsts } from '../../constants/menu';
import { useSelector } from 'react-redux';
interface propsTypes {
  drawerOpen: boolean,
  setDrawerOpen: any
}
export default function DrawerCustom(props: propsTypes) {
  const { profile } = useSelector((state: any) => state.profile)

  const { drawerOpen, setDrawerOpen } = props
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("lg"));
  // const user = getProfile() || ''
  const permit = profile?.permission || []

  console.log(permit);
 
  return (
    <>
      {!fullScreen ?
        <CardDrawer className={drawerOpen ? 'active' : ''} sx={{ display: { lg: 'block', xs: 'none' } }}>
          <HeadDrawer>
            <img src={logo.logoMenu} alt='logo_menu' width='56px' height='56px' />
          </HeadDrawer>
          <List>

            {_.map(menuFirsts, ({ code, }: any, index: number) => {
              const item = routes.find((x) => x.code === code)
              const permitActive = permit.find((x: any) => x.code === code)?.permit
              if (item && permitActive) {
                return (
                  <ListItemDrawer key={index} disablePadding>
                   <ListItemButtonDrawer className={`${drawerOpen ? 'active' : ''} ${location.pathname.includes(item.path) ? 'active-toggle' : ''}`}
                        onClick={() => {
                          if (drawerOpen) {
                            navigate(item?.path)
                            setDrawerOpen(!drawerOpen)
                          } else {
                            navigate(item?.path)
                          }
                        }}>
                        <ListItemIconDrawer>
                          {item.icon}
                        </ListItemIconDrawer>
                        <ListItemTextDrawer primary={item.textName} />
                      </ListItemButtonDrawer> 
                  </ListItemDrawer>
                )
              }
            })}
           
          </List>
        </CardDrawer > :
        <Drawer
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
        >
          <CardDrawer className={!drawerOpen ? 'active' : ''} sx={{ width: drawerOpen ? '300px' : '0px', maxWidth: drawerOpen ? '300px' : '0px', background: '#fff' }}>
            <HeadDrawer>
              <img src={logo.logoMenu} alt='logo_menu' width='56px' height='56px' />
            </HeadDrawer>
            <List>
            {_.map(menuFirsts, ({ code, }: any, index: number) => {
              const item = routes.find((x) => x.code === code)
              const permitActive = permit.find((x: any) => x.code === code)?.permit
              if (item && permitActive) {
                return (
                  <ListItemDrawer key={index} disablePadding>
                      <ListItemButtonDrawer className={`${!drawerOpen ? 'active' : 'not-active'} ${location.pathname.includes(item.path) ? 'active-toggle' : ''}`}
                        onClick={() => {
                          if (drawerOpen) {
                            navigate(item?.path)

                          } else {
                            navigate(item?.path)
                          }
                        }}>
                        <ListItemIconDrawer>
                          {item.icon}
                        </ListItemIconDrawer>
                        <ListItemTextDrawer primary={item.textName} />
                      </ListItemButtonDrawer>
                  </ListItemDrawer>
                )}})}
            </List>
          </CardDrawer >
        </Drawer>

      } </>

  )
}
